export const ALL_UNITS = -2;
